import { Routes } from '@angular/router';

export const routes: Routes = [
  { path: 'account', loadChildren: () => import('./features/account/account.routes').then(m => m.accountRoutes) },
  { path: 'donate', loadChildren: () => import('./features/donate/donate.routes').then(m => m.donateRoutes) },
  { path: 'error', loadChildren: () => import('./features/error/error.routes').then(m => m.errorRoutes) },
  { path: '', loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent) },
  
  { path: '**', redirectTo: 'error' }
];
